import { GroupContext, PREFERENCE_TYPE } from '@utils/userPreferencesUtils/Types';
import { useOpportunityReviewBoardGroupEventState } from '@components/opportunity-review-group/utils/OpportunityReviewBoardGroupContext';
import { buildNamespace, useOpportunityReviewGroupState } from '@utils/hook/userPreferences/UseGroupState';
import { useSharingConfig } from '@services/savedFilter/UseSharingConfig';
import React, { useCallback, useMemo } from 'react';
import { AddPreferencePermissionMutateResponse } from '@utils/hook/userPreferences/UseAddPermissionPreferences';
import { ShareGroupModal } from '@components/share-group-modal/ShareGroupModal';
import { FeatureOption } from '@utils/pageConfig/Types';
import { GeneralViewState } from '@models/SavedViews';
import { RetailerClient } from '@models/RetailerClient';

export interface Props {
  context: GroupContext;
  saveViewFilter: GeneralViewState;
  retailerClients: RetailerClient[];
}
export const validateCategoryOrSegmentGroup = (currentSelectedFeature: FeatureOption) => {
  return currentSelectedFeature === null || currentSelectedFeature.feature === 'Category'
    ? PREFERENCE_TYPE.categoryLeaderboardGroup
    : PREFERENCE_TYPE.featureLeaderboardGroup;
};

export const ShareOpportunityReviewBoardModalGroup: React.FC<Props> = ({
  context,
  saveViewFilter,
  retailerClients,
}) => {
  const { groupNameToBeDelete, isShareModalGroupPopUp, setIsShareModalGroupPopUp, currentSelectedFeature } =
    useOpportunityReviewBoardGroupEventState();

  const { addPreferencePermissionOpportunityReviewGroup } = useOpportunityReviewGroupState(context);

  const selectedGroupingType = validateCategoryOrSegmentGroup(currentSelectedFeature);
  const sharingConfig = useSharingConfig();
  const namespace = buildNamespace(context);

  const addPreferencePermission = useMemo<AddPreferencePermissionMutateResponse<any>>(
    () => addPreferencePermissionOpportunityReviewGroup,
    [selectedGroupingType, addPreferencePermissionOpportunityReviewGroup],
  );
  const handleClose = useCallback(() => setIsShareModalGroupPopUp(false), [setIsShareModalGroupPopUp]);

  return (
    <ShareGroupModal
      isOpen={isShareModalGroupPopUp}
      itemToShare={groupNameToBeDelete}
      onClose={handleClose}
      onSuccess={handleClose}
      onShareError={handleClose}
      getUsers={sharingConfig.getUsersForGrouping}
      getShareUserGroups={sharingConfig.getUserGroupsForGrouping}
      namespace={namespace}
      selectedGroupingType={selectedGroupingType}
      addPreferencePermission={addPreferencePermission}
      saveViewFilter={saveViewFilter}
      retailerClients={retailerClients}
    />
  );
};
